import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { AuthService } from '../../store/services/auth.service';
import { AlertService } from '../../store/services/alert.service';

import { Store } from '@ngrx/store';
import { State } from '../../store/auth/auth.reducer';
import { LoginAction } from '../../store/auth/auth.actions';
import { promise } from 'selenium-webdriver';

@Injectable()
export class AuthGuard implements CanActivate {
  constructor(
    private store: Store<State>,
    private auth: AuthService,
    private alert: AlertService,
    private router: Router,
  ) {}
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    if (this.auth.authenticate()) {
      return true;
    }
    this.alert.warning('ログインしてください');
    this.router.navigate(['entrance']);
    return false;
  }
}



// WEBPACK FOOTER //
// /Users/shwld/project/shwld/home-counter/app_src/src/app/shared/guards/auth.guard.ts